import { render, staticRenderFns } from "./SettingAccount.vue?vue&type=template&id=35ef856a"
import script from "./SettingAccount.vue?vue&type=script&lang=js"
export * from "./SettingAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports